<template>
	<div class="tasklist-title" @click="$emit('click')">
		<v-icon v-if="isOpen">mdi-chevron-down</v-icon>
		<v-icon v-else>mdi-chevron-up</v-icon>
		<div>
			<v-text-field
				style="min-width: 220px"
				v-if="isEdit"
				:value="edit_name"
				:color="color"
				:placeholder="placeholder"
				background-color="#FFFFFF"
				outlined
				dense
				hide-details
				@click.stop
				@blur="onBlur($event)"
				@keydown="onKeyDown($event)"
			></v-text-field>
			<span v-else class="task-text-status">{{name}}</span>
			<span v-if="isDynamic" class="task-text-dynamic">,&nbsp;dynamic</span>
			<span class="task-text-dynamic">,&nbsp;{{owner}}'s&nbsp;worklist</span>
		</div>
	</div>
</template>
<script>
const NEW_TASKLIST_NAME = 'Enter name of new tasklist';

export default {
	name: 'TaskTitle',
	props:{
		isOpen: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: '',
		},
		isDynamic: {
			type: Boolean,
			default: false,
		},
		owner: {
			type: String,
			default: '',
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			edit_name: this.name,
			placeholder: this.name.length === 0 ? NEW_TASKLIST_NAME: '',
		}
	},
	watch: {
		name() {
			if (this.name.length !== 0) {
				this.edit_name = this.name;
			}
			if (this.name.length === 0) {
				this.placeholder = NEW_TASKLIST_NAME;
			}
		}
	},
	methods: {
		onBlur(e) {
			this.$emit('rename', e.target.value);
		},
		onKeyDown(e) {
			if (e.keyCode === 13) {
				this.$emit('rename', e.target.value);
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.tasklist-title {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	overflow: hidden;
	&:hover {
    cursor: pointer;
  }
}
.task-text-status {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
	white-space: nowrap;
}
.task-text-dynamic {
	width: 100%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(25, 42, 62, 0.5);

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

::v-deep {
	.theme--light.v-input input::placeholder {
		color: #F45252;
	}
}



</style>